/**
 * @generated SignedSource<<6b578ccc4b0b0e67b0e5956b582ffab1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveFrom"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveTo"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "facilityLocationLineOfServiceId"
},
v3 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "effectiveFrom",
        "variableName": "effectiveFrom"
      },
      {
        "kind": "Variable",
        "name": "effectiveTo",
        "variableName": "effectiveTo"
      },
      {
        "kind": "Variable",
        "name": "facilityLocationLineOfServiceId",
        "variableName": "facilityLocationLineOfServiceId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditFacilityLocationLineOfServiceModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FacilityLocationMutationGroup",
        "kind": "LinkedField",
        "name": "facilityLocation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "FacilityLocationLineOfServiceModifyPayload",
            "kind": "LinkedField",
            "name": "modifyLineOFService",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityLocationLineOfService",
                "kind": "LinkedField",
                "name": "facilityLocationLineOfService",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacilityLocation",
                    "kind": "LinkedField",
                    "name": "facilityLocation",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityLocationLineOfService",
                        "kind": "LinkedField",
                        "name": "linesOfService",
                        "plural": true,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "FacilityLocationLineOfService"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditFacilityLocationLineOfServiceModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FacilityLocationMutationGroup",
        "kind": "LinkedField",
        "name": "facilityLocation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "FacilityLocationLineOfServiceModifyPayload",
            "kind": "LinkedField",
            "name": "modifyLineOFService",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityLocationLineOfService",
                "kind": "LinkedField",
                "name": "facilityLocationLineOfService",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacilityLocation",
                    "kind": "LinkedField",
                    "name": "facilityLocation",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityLocationLineOfService",
                        "kind": "LinkedField",
                        "name": "linesOfService",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LegalContractLineOfService",
                            "kind": "LinkedField",
                            "name": "lineOfService",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LineOfService",
                                "kind": "LinkedField",
                                "name": "lineOfService",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                  },
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "effectiveFrom",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "effectiveTo",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a061903341dbfbd6fe291e42f6952817",
    "id": null,
    "metadata": {},
    "name": "EditFacilityLocationLineOfServiceModalMutation",
    "operationKind": "mutation",
    "text": "mutation EditFacilityLocationLineOfServiceModalMutation(\n  $facilityLocationLineOfServiceId: ID!\n  $effectiveFrom: DateOnly!\n  $effectiveTo: DateOnly!\n) {\n  facilityLocation {\n    modifyLineOFService(input: {facilityLocationLineOfServiceId: $facilityLocationLineOfServiceId, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {\n      facilityLocationLineOfService {\n        id\n        facilityLocation {\n          linesOfService {\n            ...FacilityLocationLineOfService\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment FacilityLocationLineOfService on FacilityLocationLineOfService {\n  id\n  lineOfService {\n    id\n    lineOfService {\n      name\n      id\n    }\n  }\n  effectiveFrom\n  effectiveTo\n}\n"
  }
};
})();

node.hash = "47824b82b319a68c3e282b0e931d9f0d";

export default node;
